module.exports = __webpack_public_path__ + "img/gmail-buttons.dc606f75.png";